import { FeatureTogglesConstants } from "../feature-toggles.constants";
export class RuntimeFeatureToggle {
    constructor(source) {
        this.namespace = source.namespace;
        this.code = source.code;
        this.enabled = source.enabled;
    }
    getKey() {
        return `${this.namespace}${FeatureTogglesConstants.DEFAULT_NAMESPACE_SEPARATOR}${this.code}`;
    }
    toString() {
        return this.getKey();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVudGltZS1mZWF0dXJlLXRvZ2dsZS5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvZmVhdHVyZS10b2dnbGVzL21vZGVscy9ydW50aW1lLWZlYXR1cmUtdG9nZ2xlLm1vZGVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBLE9BQU8sRUFBQyx1QkFBdUIsRUFBQyxNQUFNLDhCQUE4QixDQUFDO0FBRXJFLE1BQU0sT0FBTyxvQkFBb0I7SUFLN0IsWUFDSSxNQUFxQjtRQUVyQixJQUFJLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUM7UUFDbEMsSUFBSSxDQUFDLElBQUksR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ3hCLElBQUksQ0FBQyxPQUFPLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQztJQUNsQyxDQUFDO0lBRU0sTUFBTTtRQUNULE9BQU8sR0FBRyxJQUFJLENBQUMsU0FBUyxHQUFHLHVCQUF1QixDQUFDLDJCQUEyQixHQUFHLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUNqRyxDQUFDO0lBRU0sUUFBUTtRQUNYLE9BQU8sSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ3pCLENBQUM7Q0FDSiJ9